import React from "react";
import { Check } from "lucide-react";

import PentatonicLogo from "../../assets/Pentatonic_Logo.svg";
import AuthComponent from "../Auth/AuthComponent";

export default function SignUpModal() {
  return (
    <div className="sign-in-modal bg-white p-8 w-full max-w-md mx-auto relative border border-neutral-200">
      <div>
        <div className="flex justify-center mb-6">
          <img src={PentatonicLogo} alt="Pentatonic" className="h-6 w-auto" />
        </div>
        <h2 className="text-2xl font-light text-center text-penta-black">
          Welcome to Pentatonic
        </h2>
        <p className="text-base font-light mb-10 text-center text-penta-grey-medium">
          Sign up to unlock the full experience
        </p>
        <ul className="space-y-4 text-penta-black mb-8 text-sm font-light">
          <li className="flex items-start">
            <span className="mr-3 w-6 h-6 flex items-center justify-center shrink-0 text-penta-mint">
              <Check className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <span>
              Create unlimited chats, finding your ideal match from millions of
              products with the power of AI
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-3 w-6 h-6 flex items-center justify-center shrink-0 text-penta-mint">
              <Check className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <span>
              Train Pentatonic to understand your unique preferences, tastes,
              and budget
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-3 w-6 h-6 flex items-center justify-center shrink-0 text-penta-mint">
              <Check className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <span>Benefit from new features to be launched soon</span>
          </li>
        </ul>
        <AuthComponent />
      </div>
    </div>
  );
}
